import { z } from 'zod';
import { objectIdSchema } from './objectId';

// Main ones
export enum GroupResourceType {
  FB = 'F&B',
  ENT = 'ENT',
  HSK = 'HSK',
}

export const GroupResourceTypeList = Object.values(GroupResourceType);
export const PhotographyGroupResourceTypeList = ['Photography', 'photography'];
export const AllResourceTypes = [...GroupResourceTypeList, ...PhotographyGroupResourceTypeList];

export const GroupResourceSchema = z.object({
  _id: objectIdSchema,
  resourceType: z.string(),
  price: z.number().min(0),
  name: z.string(),
  archived: z.boolean(),
  properties: objectIdSchema.array(),
  source: objectIdSchema,
  // coerce makes the date pass the zod validation after it's sent from the API
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  createdBy: z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    firstName: z.string(),
    lastName: z.string(),
  }),
  updatedBy: z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    firstName: z.string(),
    lastName: z.string(),
  }),
});

export const GroupResourceBaseSchema = GroupResourceSchema.omit({
  _id: true,
}).extend({
  properties: z.string().array(),
  source: z.string(),
});

export const UpdateGroupResourceSchema = GroupResourceSchema.extend({
  resourceType: z.string(),
}).partial();

export const CreateGroupResourceSchema = GroupResourceBaseSchema.omit({
  createdAt: true,
  updatedAt: true,
  createdBy: true,
  updatedBy: true,
}).extend({
  resourceType: z.string(),
});

export type UpdateGroupResource = z.infer<typeof UpdateGroupResourceSchema>;
export type GroupResource = z.infer<typeof GroupResourceSchema>;
export type GroupResourceBase = z.infer<typeof GroupResourceBaseSchema>;
export type CreateGroupResource = z.infer<typeof CreateGroupResourceSchema>;
